import React from 'react';
import { Col, Row } from 'react-bootstrap';
import API from '../../config/config';

const Testimonials = (props: any) => {
  return (
    <div className="testimonials-background">
      <div className="container">
        <h2 className="testimonial-h2">{props.data.name}</h2>
        <div className="testimonial-body-content">
          <Row md={2} xs={1} lg={3} xl={4}>
            {props.data.Testimonials.map((items: any, i: any) => {
              return (
                <Col key={i}>
                  <div className="testimonial-widget-container">
                    <i className="fas fa-quote-right" />
                    <div className="testiomonial-widget-content">{items.testimony}</div>
                    <Row xs={2} className="testiomonial-row-image-content">
                      <Col className="testiomonial-column-left">
                        <img
                          className="testiominal-image"
                          src={API.baseUrl + items.userPicture.url}
                          alt={items.userPicture ? items.userPicture.alternativeText : ''}
                        />
                      </Col>
                      <Col className="testiomonial-column">
                        <div className="testimonial-name">{items.userName}</div>
                        <div className="testimonial-job">{items.userOrganization}</div>
                        <div className="testimonial-job">{items.userPlace}</div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
